import React, { Component } from 'react'
import UsefulLinks from './UsefulLinks'
import Location from '../../enums/Location'
import { getAttributeCourseStaticInfo } from '../../helpers/enrolment'
import { Drawer } from '@mui/material'
import { Close } from '@mui/icons-material'

class Help extends Component {
  constructor(props) {
    super(props)

    this.state = {
      usefulLinks: [
        {
          attributes: {
            field_hamburger_link: {
              uri: 'tel:1300842864',
              title: 'Call us'
            },
            field_icon_svg: 'CommunicationPhone'
          }
        },
        {
          attributes: {
            field_hamburger_link: {
              uri: 'https://askvu.vu.edu.au/app/ask',
              title: 'Email'
            },
            field_icon_svg: 'CommunicationMailOutline'
          }
        },
        {
          attributes: {
            field_type: 'chat',
            field_hamburger_link: {
              uri: 'https://askvu.vu.edu.au/app/vuchat',
              title: 'Chat'
            },
            field_icon_svg: 'CommunicationChat'
          }
        },
        {
          attributes: {
            field_hamburger_link: {
              uri:
                'https://www.vu.edu.au/contact-us/vuhq-student-service-centres',
              title: 'Visit VUHQ'
            },
            field_icon_svg: 'ActionSupervisorAccount'
          }
        }
      ]
    }
  }

  componentDidMount() {
    let locationCd = getAttributeCourseStaticInfo('locationCd')
    if (locationCd && locationCd === Location.ZV) {
      this.setState({
        usefulLinks: [
          {
            attributes: {
              field_hamburger_link: {
                uri: 'tel:1300043531',
                title: 'Call us'
              },
              field_icon_svg: 'CommunicationPhone'
            }
          },
          {
            attributes: {
              field_hamburger_link: {
                uri: 'mailto:futurestudy@online.vu.edu.au',
                title: 'Email'
              },
              field_icon_svg: 'CommunicationMailOutline'
            }
          },
          {
            attributes: {
              field_hamburger_link: {
                uri: 'https://online.vu.edu.au',
                title: 'Chat'
              },
              field_icon_svg: 'CommunicationChat'
            }
          }
        ]
      })
    }
  }

  render() {
    return (
      <Drawer
        PaperProps={{ style: { width: 320, height: '100%', overflowY: 'auto' } }}
        anchor='right'
        onClose={this.onClose}
        open={this.props.open}
        className="slidein"
      >
        <div className="slidein__content">
          <div className="slidein__close">
            <button className="slidein__btn-close" onClick={this.props.onClose}>
              <Close className="btn-point-events" />
            </button>
          </div>

          <UsefulLinks usefulLinks={this.state.usefulLinks} />
        </div>
      </Drawer>
    )
  }
}

export default Help
